// @flow
// TODO - move to stateProcessors/index.js

import type { Uploader } from "uploader";
import { getLogger } from "common/logger";
import { EVENT_TYPES } from "./common/events";

import {
	selectLatestConfig,
	selectHideData,
	selectShowCounter,
	selectShowData,
	selectRetrievedTags,
	selectRetrievedUploadPresets,
	selectMinimizeCounter,
	selectSuccessCounter,
} from "./store/selectors";
import processQueues from "./stateProcessors/queuesProcessor";
import processCloudNameChange from "./stateProcessors/cloudNameChangeProcessor";
import processCloudInfo from "./stateProcessors/cloudInfoProcessor";
import processFiles from "./stateProcessors/filesProcessor";
import processClientUploadsBatch from "./stateProcessors/clientUploadBatchProcessor";

const logger = getLogger();

const processShow = (newState: Object, prevState: Object, uploader: Uploader) => {
	if (selectShowCounter(newState) > selectShowCounter(prevState)) {
		const newShowData = selectShowData(newState);
		const data = {
			source: undefined,
		};

		if (newShowData.source !== selectShowData(prevState).source) {
			data.source = newShowData.source;
		}

		if (newShowData.options?.fileDialog) {
			logger.log("[uploader.stateProcessors]: showing file dialog with show event");
			uploader.showFileDialog();
		}

		logger.log("[uploader.stateProcessors]: received show event data ", data);
		uploader.emit(EVENT_TYPES.UPLOADER_SHOW, data);
	}
};

const processConfig = (newState: Object, prevState: Object, emit) => {
	const prevConfig = selectLatestConfig(prevState);
	const newConfig = selectLatestConfig(newState);

	if (!prevConfig && newConfig) {
		emit(EVENT_TYPES.UPLOADER_READY);
	}

	if (prevConfig && prevConfig !== newConfig) {
		emit(EVENT_TYPES.UPLOADER_UPDATE_SETTINGS, newConfig);
	}
};

const processMinimize = (newState: Object, prevState: Object, emit: Function) => {
	if (selectMinimizeCounter(newState) > selectMinimizeCounter(prevState)) {
		logger.log("[uploader.stateProcessors]: received client minimize event");
		emit(EVENT_TYPES.UPLOADER_CLIENT_MINIMIZE);
	}
};

const processHide = (newState: Object, prevState: Object, emit: Function) => {
	const newHideData = selectHideData(newState);
	if (newHideData.counter > selectHideData(prevState).counter) {
		logger.log("[uploader.stateProcessors]: received client hide event with options: ", newHideData.options);
		emit(EVENT_TYPES.UPLOADER_CLIENT_HIDE);
	}
};

const processRetrievedTags = (newState: Object, prevState: Object, emit: Function) => {
	const newTags = selectRetrievedTags(newState);

	if (newTags !== selectRetrievedTags(prevState)) {
		logger.log("[uploader.stateProcessors]: received new tags from client");
		emit(EVENT_TYPES.UPLOADER_CLIENT_TAGS, { tags: newTags });
	}
};

const processRetrievedUploadPresets = (newState: Object, prevState: Object, emit: Function) => {
	const newUploadPresets = selectRetrievedUploadPresets(newState);

	if (newUploadPresets !== selectRetrievedUploadPresets(prevState)) {
		logger.log("[uploader.stateProcessors]: received new upload presets from client");
		emit(EVENT_TYPES.UPLOADER_CLIENT_UPLOAD_PRESETS, { uploadPresets: newUploadPresets });
	}
};


const processSuccessCounter = (newState: Object, prevState: Object, emit: Function) => {
	const newCount = selectSuccessCounter(newState);

	if (newCount !== selectSuccessCounter(prevState)) {
		emit(EVENT_TYPES.UPLOADER_SUCCESS_COUNTER, { count: newCount });
	}
};

const processStateChange = (newState: Object,
	prevState: Object,
	uploader: Object,
	sendExternalEvent: Function,
	actions: { [string]: Function }) => {
	// TODO - refactor each processor to a separate file

	processConfig(newState, prevState, uploader.emit);
	processFiles(newState, prevState, uploader, sendExternalEvent);
	processShow(newState, prevState, uploader);
	processHide(newState, prevState, uploader.emit);
	processMinimize(newState, prevState, uploader.emit);
	processQueues(newState, prevState, uploader);
	processRetrievedTags(newState, prevState, uploader.emit);
	processRetrievedUploadPresets(newState, prevState, uploader.emit);
	processClientUploadsBatch(newState, prevState, uploader, actions);
	processCloudInfo(newState, prevState, uploader /* , actions */);
	processCloudNameChange(newState, prevState, uploader, actions);
	processSuccessCounter(newState, prevState, uploader.emit);
};

export default (uploader: Object, sendExternalEvent: Function, actions: { [string]: Function }) =>
	(newState: Object, prevState: Object) =>
		processStateChange(newState, prevState, uploader, sendExternalEvent, actions);
